export default "__VITE_ASSET__CFQ3wDsa__"